"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Overview/AddOrgModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _noticeBar = require('web/services/context/noticeBar');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');







// Adds an org to the account any of whose orgs is accountOrgKey, then loads
// the new org and the membership the account gave the caller.
 const addAccountOrg = async (accountOrgKey, Name) => {
  const { OrgKey } = await _actions2.default.createAccountOrg({ OrgKey: accountOrgKey, Name })
  await Promise.all([_actions2.default.getMe(), _actions2.default.getOrgs({ OrgKeys: [OrgKey] })]).catch(() => undefined)
}; exports.addAccountOrg = addAccountOrg

const MAX_NAME_LENGTH = 100 // CreateAccountOrg allows at most 100 characters

// Adds an org to the account (screen 02).
const AddOrgModal = ({ isOpen, onClose, onProceed }) => {
  const [name, setName] = _react.useState.call(void 0, '')
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const trimmed = name.trim()

  const close = () => {
    setName('')
    onClose()
  }

  const submit = () => {
    setIsLoading(true)
    onProceed(trimmed)
      .then(() => showSuccessBar(`Added ${trimmed}.`))
      .then(close)
      .catch(() => showWarningBar('Failed to add the organization.'))
      .finally(() => setIsLoading(false))
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: isLoading ? undefined : close, title: "Add organization" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
      , _react2.default.createElement('label', { className: "settings--org-api-keys--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "Organization name"

        , _react2.default.createElement(_Form.TextInput, {
          autoFocus: true,
          value: name,
          maxLength: MAX_NAME_LENGTH,
          onChange: e => setName(e.target.value),
          placeholder: "E.g. Northern Kentucky"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        )
      )
      , _react2.default.createElement(_Modal.ModalDesc, { className: "settings--acct--callout", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "Owners and IT join it automatically, with no team. Account settings, the plan and API keys apply to it."

      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Add organization" ,
        isPrimaryEnabled: !!trimmed,
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: submit,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: isLoading ? undefined : close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      )
    )
  )
}

exports. default = AddOrgModal
